export function descendingComparator(a, b, orderBy) {
  const aVal = a[orderBy] ?? 0;
  const bVal = b[orderBy] ?? 0;
  if (typeof aVal === 'string') return bVal.localeCompare(aVal);
  return bVal - aVal;
}

export function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}
